/* Wrought "forge" style, carried over from the Built in Silence teaser to the whole site:
   - big headings fade in word by word when they scroll into view
   - an ember sword line draws in under each heading group
   - a soft ember glow sits behind text sections (never over photos)
   - email signup boxes get the ember treatment
   - product pages: framed images; collection pages: a centered title header */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var main = document.querySelector('main[data-template]');
  if (!main) return;
  var tpl = main.getAttribute('data-template') || '';

  var CSS =
    // Word reveal
    '.wr-fx .wr-fw { display: inline-block; opacity: 0; transform: translateY(14px); filter: blur(6px); transition: opacity .9s cubic-bezier(.2,.7,.1,1), transform .9s cubic-bezier(.2,.7,.1,1), filter .9s ease; transition-delay: calc(var(--i) * 90ms); }' +
    '.wr-fx.is-in .wr-fw { opacity: 1; transform: none; filter: none; }' +
    // Sword divider
    '.wr-blade { display: block; width: min(300px, 70%); height: 12px; margin: 18px 0 6px; overflow: visible; pointer-events: none; }' +
    '.wr-blade--center { margin-left: auto; margin-right: auto; }' +
    '.wr-blade--end { margin-left: auto; }' +
    '.wr-blade path { fill: none; stroke: #e0703a; stroke-width: 1; stroke-dasharray: 1; stroke-dashoffset: 1; transition: stroke-dashoffset 1.3s ease .35s; filter: drop-shadow(0 0 4px rgba(224, 112, 58, .7)); }' +
    '.wr-blade.is-in path { stroke-dashoffset: 0; }' +
    // Glow behind text sections
    '.wr-glow-host { position: relative; }' +
    '.wr-glowbox { position: absolute; inset: 0; overflow: hidden; pointer-events: none; z-index: 1; mix-blend-mode: screen; }' +
    '.wr-glowbox::before { content: ""; position: absolute; left: var(--gx, 50%); top: var(--gy, 0px); width: min(860px, 130%); height: 520px; transform: translate(-50%, -45%); background: radial-gradient(closest-side, rgba(224, 112, 58, .15), transparent 72%); animation: wr-glow-breathe 8s ease-in-out infinite; }' +
    '@keyframes wr-glow-breathe { 0%,100% { opacity: .65; } 50% { opacity: 1; } }' +
    // Email signup boxes: the teaser's ember box, everywhere
    '.email-signup__input-group { display: flex !important; align-items: stretch; border: 1px solid #3a2a20 !important; border-radius: 0 !important; background: #0b0b0b !important; transition: border-color .3s ease, box-shadow .3s ease; overflow: hidden; }' +
    '.email-signup__input-group:focus-within { border-color: #e0703a !important; box-shadow: 0 0 0 1px #e0703a, 0 0 18px rgba(224, 112, 58, .25); }' +
    '.email-signup__input-group .email-signup__input { flex: 1; min-width: 0; border: 0 !important; border-radius: 0 !important; background: transparent !important; color: #ece6d9 !important; box-shadow: none !important; font-size: 16px !important; padding: 15px 16px !important; outline: none; }' +
    '.email-signup__input-group .email-signup__input::placeholder { color: #6f6a61 !important; }' +
    '.email-signup__input-group .email-signup__button { position: static !important; transform: none !important; flex: none; align-self: stretch; height: auto !important; min-height: 50px; margin: 0 !important; border: 0 !important; border-radius: 0 !important; background: #e0703a !important; color: #0b0b0b !important; font-size: 12px !important; font-weight: 600 !important; letter-spacing: .22em; text-transform: uppercase; padding: 0 20px !important; transition: background .25s ease; }' +
    '.email-signup__input-group .email-signup__button:hover { background: #f08a50 !important; }' +
    '.email-signup__input-group .email-signup__button--arrow svg { display: none !important; }' +
    '.email-signup__input-group .email-signup__button--arrow::after { content: "Join"; }' +
    '.email-signup__input-group .email-signup__button:focus-visible { outline: 2px solid #ece6d9; outline-offset: -4px; }' +
    // Product pages: framed images
    'main[data-template^="product"] media-gallery .product-media-container { border: 1px solid #1f1a17; }' +
    // Collection header
    '.wr-coll-head .layout-panel-flex { align-items: center !important; justify-content: center !important; text-align: center; }' +
    '.wr-coll-head .text-block { width: auto !important; text-align: center !important; margin-left: auto !important; margin-right: auto !important; align-items: center !important; justify-content: center !important; }' +
    '.wr-coll-head h1 { width: 100%; }' +
    '.wr-coll-head h1 { font-size: clamp(40px, 7vw, 92px) !important; line-height: .95 !important; letter-spacing: .02em; text-transform: uppercase !important; text-align: center; }' +
    '.wr-coll-head { padding-top: clamp(28px, 5vw, 64px); padding-bottom: clamp(8px, 2vw, 20px); }' +
    '.wr-eyebrow { display: block; margin: 0 0 14px !important; font-family: var(--font-body--family, sans-serif) !important; font-size: 11px !important; font-weight: 400 !important; line-height: 1.4 !important; letter-spacing: .4em !important; text-transform: uppercase !important; color: #e0703a !important; text-align: center; }' +
    '@media (prefers-reduced-motion: reduce) { .wr-fx .wr-fw { opacity: 1; transform: none; filter: none; transition: none; } .wr-blade path { stroke-dashoffset: 0; transition: none; } .wr-glowbox::before { animation: none; } }';

  var st = document.createElement('style');
  st.textContent = CSS;
  document.head.appendChild(st);

  var SKIP = '.wr-teaser, product-card, .product-card, header, footer, dialog, [id$="__section_JpEEkW"], .wr-pairs, .wr-quiz, .wr-mark';

  function splitWords(el) {
    if (el.dataset.wrFx) return;
    el.dataset.wrFx = '1';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [], n = 0;
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!node.textContent.trim()) return;
      var frag = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var s = document.createElement('span');
        s.className = 'wr-fw';
        s.style.setProperty('--i', n++);
        s.textContent = part;
        frag.appendChild(s);
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.classList.add('wr-fx');
  }

  function blade(align) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'wr-blade wr-blade--' + align);
    svg.setAttribute('viewBox', '0 0 400 12');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    ['M0 6 L180 6 M220 6 L400 6', 'M190 6 L200 1 L210 6 L200 11 Z'].forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      p.setAttribute('pathLength', '1');
      svg.appendChild(p);
    });
    return svg;
  }

  function alignOf(el) {
    var a = getComputedStyle(el).textAlign;
    if (a === 'center') return 'center';
    if (a === 'right' || a === 'end') return 'end';
    return 'start';
  }

  function isHeading(el) {
    if (el.closest(SKIP)) return false;
    if (el.querySelector('ul, img, video')) return false;
    if (!el.textContent.trim() || el.textContent.trim().length > 90) return false;
    if (el.matches('h1') || el.matches('.text-block.h1, .text-block.h2')) return true;
    return el.matches('.text-block') && parseFloat(getComputedStyle(el).fontSize) >= 40;
  }

  function hasPhoto(section) {
    var w = section.getBoundingClientRect().width || 1;
    return Array.prototype.some.call(section.querySelectorAll('img, video'), function (m) {
      return m.getBoundingClientRect().width > w * 0.4;
    });
  }

  var io = 'IntersectionObserver' in window && !reduce
    ? new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -40px 0px' })
    : null;

  function show(el) { if (io) io.observe(el); else el.classList.add('is-in'); }

  function collectionHead() {
    if (!/^collection/.test(tpl)) return;
    var h = main.querySelector('h1');
    if (!h || h.closest('.wr-teaser')) return;
    var sec = h.closest('.shopify-section');
    if (!sec || sec.classList.contains('wr-coll-head')) return;
    sec.classList.add('wr-coll-head');
    var eb = document.createElement('span');
    eb.className = 'wr-eyebrow';
    eb.textContent = 'Wrought / Collection';
    h.parentNode.insertBefore(eb, h);
  }

  function run() {
    collectionHead();
    var found = [];
    Array.prototype.forEach.call(main.querySelectorAll('h1, .text-block'), function (el) {
      // Use the text block wrapper when a heading sits inside one, so we don't handle it twice.
      if (el.matches('h1') && el.parentElement && el.parentElement.matches('.text-block')) return;
      if (isHeading(el)) found.push(el);
      else if (el.matches('.text-block') && el.querySelector(':scope > h1') && !el.closest(SKIP)) found.push(el);
    });

    found.forEach(function (el, i) {
      splitWords(el);
      show(el);
      // One sword line under the last heading of a stacked group.
      var next = found[i + 1];
      var stacked = next && el.nextElementSibling === next;
      if (!stacked && !(el.nextElementSibling && el.nextElementSibling.classList && el.nextElementSibling.classList.contains('wr-blade'))) {
        var b = blade(alignOf(el.querySelector('h1') || el));
        el.after(b);
        show(b);
      }
      // Glow behind text sections only, never over photos.
      var sec = el.closest('.shopify-section');
      if (sec && !sec.querySelector(':scope > .wr-glowbox') && !hasPhoto(sec)) {
        sec.classList.add('wr-glow-host');
        var g = document.createElement('div');
        g.className = 'wr-glowbox';
        g.setAttribute('aria-hidden', 'true');
        var sr = sec.getBoundingClientRect(), er = el.getBoundingClientRect();
        g.style.setProperty('--gx', Math.round(er.left - sr.left + er.width / 2) + 'px');
        g.style.setProperty('--gy', Math.round(er.top - sr.top + er.height / 2) + 'px');
        sec.appendChild(g);
      }
    });
  }

  // ---------- Scan line (from the teaser cards) ----------
  // A faint ember band sweeps down over product images: once as they come into view,
  // again on hover, and on a slow loop over the main product photo.
  var SCAN_CSS =
    '.wr-scan-host { position: relative; overflow: hidden; }' +
    '.wr-scan { position: absolute; left: 0; right: 0; top: -35%; height: 35%; z-index: 2; pointer-events: none; opacity: 0;' +
    ' background: linear-gradient(transparent, rgba(var(--wr-scan-rgb), var(--wr-scan-a)) 50%, transparent); }' +
    // Steel-white light all year; the ember orange comes back for October.
    ':root { --wr-scan-rgb: 246, 240, 230; --wr-scan-a: .13; }' +
    ':root.wr-october { --wr-scan-rgb: 224, 112, 58; --wr-scan-a: .16; }' +
    '.wr-quiz .wr-quiz__pick-img::after { background: linear-gradient(transparent, rgba(var(--wr-scan-rgb), calc(var(--wr-scan-a) + .04)) 50%, transparent); }' +
    '.wr-teaser .wr-teaser__scan { background: linear-gradient(transparent, rgba(var(--wr-scan-rgb), calc(var(--wr-scan-a) - .03)), transparent); }' +
    '.wr-scan-host.is-scanning > .wr-scan { animation: wr-scan 1.7s cubic-bezier(.45,.05,.55,.95) both; }' +
    '.wr-scan-host--loop > .wr-scan { animation: wr-scan 1.9s cubic-bezier(.45,.05,.55,.95) infinite; animation-delay: 1.2s; }' +
    '@keyframes wr-scan { 0% { top: -35%; opacity: 0; } 12% { opacity: 1; } 88% { opacity: 1; } 100% { top: 100%; opacity: 0; } }' +
    // The loop rests between passes so it stays a detail, not a distraction.
    '@keyframes wr-scan-rest { 0% { top: -35%; opacity: 0; } 4% { opacity: 1; } 30% { opacity: 1; } 34% { top: 100%; opacity: 0; } 100% { top: 100%; opacity: 0; } }' +
    '.wr-scan-host--loop > .wr-scan { animation-name: wr-scan-rest; animation-duration: 6.5s; animation-timing-function: linear; }' +
    '@media (prefers-reduced-motion: reduce) { .wr-scan { display: none; } }';

  function scanOnce(host) {
    if (host.classList.contains('is-scanning')) return;
    host.classList.add('is-scanning');
    setTimeout(function () { host.classList.remove('is-scanning'); }, 1800);
  }

  var scanIO = 'IntersectionObserver' in window && !reduce
    ? new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var host = e.target;
          setTimeout(function () { scanOnce(host); }, (+host.dataset.wrScanDelay || 0));
          scanIO.unobserve(host);
        });
      }, { threshold: 0.4 })
    : null;

  function addScan(host, opts) {
    if (!host || host.dataset.wrScan) return;
    host.dataset.wrScan = '1';
    host.classList.add('wr-scan-host');
    var s = document.createElement('span');
    s.className = 'wr-scan';
    s.setAttribute('aria-hidden', 'true');
    host.appendChild(s);
    if (reduce) return;
    if (opts && opts.loop) { host.classList.add('wr-scan-host--loop'); return; }
    if (opts && opts.delay) host.dataset.wrScanDelay = opts.delay;
    if (scanIO) scanIO.observe(host);
    host.addEventListener('mouseenter', function () { scanOnce(host); });
  }

  function initScan() {
    var st2 = document.createElement('style');
    st2.textContent = SCAN_CSS;
    document.head.appendChild(st2);

    function cards(root) {
      Array.prototype.forEach.call((root || document).querySelectorAll('product-card .card-gallery'), function (g, i) {
        addScan(g, { delay: (i % 4) * 140 });
      });
      Array.prototype.forEach.call((root || document).querySelectorAll('.wr-pairs__img'), function (g, i) {
        addScan(g, { delay: i * 140 });
      });
    }
    cards();
    // Cards that arrive later (filters, recommendations).
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) cards(n); });
      });
    }).observe(main, { childList: true, subtree: true });

    // Product page: the main photo gets the slow loop, the rest sweep on hover.
    if (/^product/.test(tpl)) {
      var media = main.querySelectorAll('media-gallery .product-media-container');
      Array.prototype.forEach.call(media, function (m, i) { addScan(m, i === 0 ? { loop: true } : null); });
    }
  }

  // ---------- Category tabs on collection pages ----------
  var TABS = [
    ['All', '/collections/clothing'],
    ['Tees', '/collections/tees'],
    ['Hoodies & Layers', '/collections/hoodies'],
    ['Outerwear', '/collections/outerwear'],
    ['Accessories', '/collections/accessories'],
    ['Not sure? Find your piece →', '/pages/find-your-piece', 'quiz']
  ];
  var TAB_CSS =
    '.wr-tabs { display: flex; justify-content: center; flex-wrap: wrap; gap: 8px; max-width: var(--page-width, 1400px); margin: 0 auto; padding: 4px 16px clamp(16px, 3vw, 28px); }' +
    '.wr-tabs a { display: inline-block; padding: 9px 16px; border: 1px solid #2a211b; color: #b9b2a5; font-size: 11px; letter-spacing: .24em; text-transform: uppercase; text-decoration: none; transition: color .25s ease, border-color .25s ease, background .25s ease, box-shadow .25s ease; }' +
    '.wr-tabs a:hover { color: #ece6d9; border-color: #5a3a26; }' +
    '.wr-tabs a[aria-current="page"] { color: #0b0b0b; background: #e0703a; border-color: #e0703a; box-shadow: 0 0 14px rgba(224, 112, 58, .35); }' +
    '.wr-tabs a.wr-tabs__quiz { border-color: transparent; color: #e0703a; }' +
    '.wr-tabs a.wr-tabs__quiz:hover { border-color: #5a3a26; color: #f0a36b; }' +
    '.wr-tabs a:focus-visible { outline: 2px solid #e0703a; outline-offset: 2px; }' +
    '@media (max-width: 749px) { .wr-tabs { flex-wrap: nowrap; justify-content: flex-start; overflow-x: auto; scrollbar-width: none; -webkit-mask-image: linear-gradient(90deg, #000 88%, transparent); mask-image: linear-gradient(90deg, #000 88%, transparent); } .wr-tabs::-webkit-scrollbar { display: none; } .wr-tabs a { flex: none; } }';

  function initTabs() {
    if (!/^collection/.test(tpl) || main.querySelector('.wr-teaser')) return;
    var head = main.querySelector('.wr-coll-head');
    if (!head || main.querySelector('.wr-tabs')) return;
    var here = location.pathname.replace(/\/$/, '');
    var nav = document.createElement('nav');
    nav.className = 'wr-tabs';
    nav.setAttribute('aria-label', 'Shop by category');
    TABS.forEach(function (t) {
      var a = document.createElement('a');
      a.href = t[1];
      a.textContent = t[0];
      if (here === t[1]) a.setAttribute('aria-current', 'page');
      if (t[2]) a.className = 'wr-tabs__' + t[2];
      nav.appendChild(a);
    });
    var st3 = document.createElement('style');
    st3.textContent = TAB_CSS;
    document.head.appendChild(st3);
    head.after(nav);
  }

  // ---------- Sticky add to cart: the theme already has one; give it the ember treatment ----------
  var BAR_CSS =
    '.sticky-add-to-cart__bar { border-radius: 0 !important; border: 1px solid #2a211b !important; background: rgba(10, 9, 8, .92) !important; -webkit-backdrop-filter: blur(12px); backdrop-filter: blur(12px); box-shadow: 0 -8px 30px rgba(0, 0, 0, .5), inset 0 1px 0 rgba(224, 112, 58, .55) !important; }' +
    '.sticky-add-to-cart__image, .sticky-add-to-cart__image-img { border-radius: 0 !important; }' +
    '.sticky-add-to-cart__button { background: #e0703a !important; color: #0b0b0b !important; border: 0 !important; border-radius: 0 !important; font-size: 12px !important; font-weight: 600 !important; letter-spacing: .2em; text-transform: uppercase; transition: background .25s ease; }' +
    '.sticky-add-to-cart__button:hover { background: #f08a50 !important; }' +
    '.sticky-add-to-cart__button svg { color: #0b0b0b; }';

  function initBuyBar() {
    if (!/^product/.test(tpl)) return;
    var st4 = document.createElement('style');
    st4.textContent = BAR_CSS;
    document.head.appendChild(st4);
  }

  // ---------- Footer: FAQ link, real TikTok link, hide social links with no address ----------
  function initFooter() {
    var links = document.querySelectorAll('footer a');
    Array.prototype.forEach.call(links, function (a) {
      var label = a.textContent.trim();
      if (label === 'Size Guide' && !document.querySelector('footer a[href="/pages/faq"]')) {
        var wrap = a.closest('.shopify-block') || a;
        var copy = wrap.cloneNode(true);
        var ca = copy.matches('a') ? copy : copy.querySelector('a');
        ca.href = '/pages/faq';
        var span = ca.querySelector('span') || ca;
        span.textContent = 'FAQ';
        copy.removeAttribute('id');
        wrap.after(copy);
      }
      if (/^(Catalog)$/.test(label) && /\/collections\/all\/?$/.test(a.getAttribute('href') || '')) a.href = '/collections/clothing';
      if (label === 'TikTok' && !/tiktok\.com/.test(a.getAttribute('href') || '')) {
        a.href = 'https://www.tiktok.com/@wearwrought';
        a.removeAttribute('aria-disabled');
        a.removeAttribute('role');
        a.target = '_blank';
        a.rel = 'noopener';
      }
      if ((label === 'Facebook' || label === 'Instagram') && !(a.getAttribute('href') || '').replace(/#|javascript:.*/g, '')) {
        (a.closest('.shopify-block') || a).style.display = 'none';
      }
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    try { initFooter(); } catch (e) {}
    try { run(); } catch (e) {}
    try { initScan(); } catch (e) {}
    try { initTabs(); } catch (e) {}
    try { initBuyBar(); } catch (e) {}
  });
})();
